"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MarkerPolygon;
var _react = _interopRequireDefault(require("react"));
var _reactKonva = require("react-konva");
var _Text = _interopRequireDefault(require("./Text"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["data", "name", "rotation"]; // https://stackoverflow.com/a/67793914
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function MarkerPolygon(_ref) {
  var data = _ref.data,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? "marker-polygon" : _ref$name,
    rotation = _ref.rotation,
    listeners = _objectWithoutProperties(_ref, _excluded);
  var characteristics = data.characteristics,
    _data$markerPixelXInd = data.markerPixelXIndices,
    markerPixelXIndices = _data$markerPixelXInd === void 0 ? [] : _data$markerPixelXInd,
    _data$markerPixelIndi = data.markerPixelIndices_OutputImageCoordinates,
    markerPixelIndices_OutputImageCoordinates = _data$markerPixelIndi === void 0 ? [] : _data$markerPixelIndi;
  var pointArray = markerPixelIndices_OutputImageCoordinates !== null && markerPixelIndices_OutputImageCoordinates !== void 0 ? markerPixelIndices_OutputImageCoordinates : markerPixelXIndices;
  if (markerPixelXIndices.length < 1) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {});
  }
  var labelOffset = 10;
  var tempMax = characteristics.markerTempC_Max;
  var tempMin = characteristics.markerTempC_Min;
  var lines = pointArray.map(function (start, i) {
    var end = pointArray[(i + 1) % pointArray.length];
    return {
      startX: start.X,
      startY: start.Y,
      endX: end.X,
      endY: end.Y
    };
  });
  var xMin = Math.min.apply(Math, _toConsumableArray(pointArray.map(function (point) {
    return point.X;
  })));
  var xMax = Math.max.apply(Math, _toConsumableArray(pointArray.map(function (point) {
    return point.X;
  })));
  var yMax = Math.max.apply(Math, _toConsumableArray(pointArray.map(function (point) {
    return point.Y;
  })));
  var polygonWidth = xMax - xMin;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.default.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactKonva.Line, _objectSpread({
      name: name,
      points: lines.map(function (p) {
        return [p.X, p.Y];
      }).flat(),
      stroke: "white"
    }, listeners)), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
      x: xMin + polygonWidth / 2,
      y: yMax + labelOffset,
      text: characteristics.markerName,
      rotation: rotation
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
      x: Math.min.apply(Math, _toConsumableArray(pointArray)) + polygonWidth / 2,
      y: yMax - labelOffset,
      text: "Max: ".concat(tempMax, "\nMin: ").concat(tempMin),
      rotation: rotation
    })]
  });
}